import {
  getAllServices,
  queryAllSkills,
  executeAction,
  zmNotifyListeners,
} from './base';
import {
  getService,
  callAction,
  getAvailableServices,
  registerJSService,
  unregisterJSService,
  getRegisteredJSServices,
  onServiceChanged,
  offServiceChanged,
  destroy,
} from './core/service-hub';

export default {
  getService,
  callAction,
  getAvailableServices,
  onServiceChanged,
  offServiceChanged,
  destroy,
  getAllServices,
  queryAllSkills,
  executeAction,
  registerJSService,
  unregisterJSService,
  getRegisteredJSServices,
  zmNotifyListeners,
};
